import React, { createContext, useContext, useEffect, useState } from "react";
import SignIn from "../auth/SignIn";
import SignUp from "../auth/SignUp";
import OtpVerification from "../auth/OtpVerification";
import ForgotPassword from "../auth/ForgotPassword";
import ResetPassword from "../auth/ResetPassword";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from '../../assets/svg/AI.Logo.svg';

export const ComponentContext = createContext();

const Modal = ({ isOpen, onClose }) => {
  const [currentComponent, setCurrentComponent] = useState("signIn");
  const [userData, setUserData] = useState(null); // Store user data
  const navigate = useNavigate();
  const location = useLocation();

  // Extract token from URL query parameters
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  useEffect(() => {
    if (token) {
      setCurrentComponent("resetPassword");
    }
  }, [token]);

  if (!isOpen) return null;

  return (
    <ComponentContext.Provider
      value={{
        currentComponent,
        setCurrentComponent,
        userData,
        setUserData,
        onClose,
      }}
    >
      <div
        onClick={() => onClose(setCurrentComponent,"signIn")}
        className="fixed inset-0 flex p-5 items-center justify-center bg-black bg-opacity-50 z-50"
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-white p-6 rounded-[30px] shadow-lg w-[450px]"
        >
          {/* Modal Header */}

          <div className="flex justify-center items-center mb-4">
            <img
              src={Logo}
              alt="OfficeFinder Logo"
              className="h-10 sm:h-12 md:h-14 w-auto object-contain max-w-[130px] sm:max-w-[140px] md:max-w-[160px] transition-all"
            />
          </div>

          <div className="overflow-y-scroll max-h-[450px]">
            {currentComponent === "signIn" && <SignIn />}

            {currentComponent === "signUp" && <SignUp />}

            {currentComponent === "otpVerification" && (
              <OtpVerification userData={userData} />
            )}

            {currentComponent === "forgotPassword" && <ForgotPassword />}
            {currentComponent === "resetPassword" && <ResetPassword />}
          </div>
        </div>
      </div>
    </ComponentContext.Provider>
  );
};

export const useComponent = () => useContext(ComponentContext);
export default Modal;
